import { Box, Card, Grid, Link, styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ILead } from 'wisestep-api';
import { Item, WsTypography, WsTypoColors } from 'wisestep-base';

interface LeadInfoTabProp {
  leadInfo: ILead;
  tabIndex?: number;
}

const StyledItem = styled(Item)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const LeadInfoTab = ({ leadInfo }: LeadInfoTabProp) => {
  const goBackUrl = `/leads/details?leadId=${leadInfo.id}`;

  return (
    <Card sx={{ width: '100%', p: 1 }}>
      <Item>
        <WsTypography bold={true}>Basic Information</WsTypography>
      </Item>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <StyledItem>
            <WsTypography color={WsTypoColors.SECONDARY}>Lead Owner</WsTypography>
            <Box width="50%">
              <Link
                component={RouterLink}
                to={`/users/details-page?email=${leadInfo.leadOwnerInfo?.id}&isLink=true&isUserAnalytics=true`}
                sx={{
                  textDecoration: 'none',
                }}
              >
                <WsTypography display="inline" color={WsTypoColors.PRIMARY} cursor="pointer">
                  {leadInfo.leadOwnerInfo?.name || leadInfo.leadOwnerInfo?.id}
                </WsTypography>
              </Link>
            </Box>
          </StyledItem>
        </Grid>
        <Grid item xs={4}>
          <StyledItem>
            <WsTypography color={WsTypoColors.SECONDARY}>Business Unit</WsTypography>
            <Box width="50%">
              <WsTypography>
                {leadInfo.businessUnitsInfo?.buinfo?.map((bu) => bu.name).join(', ')}
              </WsTypography>
            </Box>
          </StyledItem>
        </Grid>
        <Grid item xs={4}>
          <StyledItem>
            <WsTypography color={WsTypoColors.SECONDARY}>Organization Entity</WsTypography>
            <Box width="50%">
              <WsTypography>{leadInfo.organisationEntityName}</WsTypography>
            </Box>
          </StyledItem>
        </Grid>
        <Grid item xs={4}>
          <Item sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <WsTypography color={WsTypoColors.SECONDARY}>Client</WsTypography>
            <Box width="50%">
              <Link
                component={RouterLink}
                to={`/client-details?clientId=${leadInfo.client?.id}&name=${leadInfo.client?.name}\
                    &isChild=true&tabIndex=0&goBack=true&goBackUrl=${goBackUrl}`}
                sx={{
                  textDecoration: 'none',
                }}
              >
                <WsTypography display="inline" color={WsTypoColors.PRIMARY} cursor="pointer">
                  {leadInfo.client?.name}
                </WsTypography>
              </Link>
            </Box>
          </Item>
        </Grid>
        <Grid item xs={4}>
          <StyledItem>
            <WsTypography color={WsTypoColors.SECONDARY}>Client Contact</WsTypography>
            <Box width="50%">
              <Link
                component={RouterLink}
                to={`/${leadInfo.clientContact?.id}/client-contact-details?name=${leadInfo.clientContact?.clientName}&isChild=true\
                    &clientId=${leadInfo.clientContact?.clientId}&goBack=true&goBackUrl=${goBackUrl}`}
                sx={{
                  textDecoration: 'none',
                }}
              >
                <WsTypography display="inline" color={WsTypoColors.PRIMARY} cursor="pointer">
                  {leadInfo.clientContact?.firstName} {leadInfo.clientContact?.lastName}
                </WsTypography>
              </Link>
            </Box>
          </StyledItem>
        </Grid>
        <Grid item xs={4}>
          <StyledItem>
            <WsTypography color={WsTypoColors.SECONDARY}>Source</WsTypography>
            <Box width="50%">
              <WsTypography>{leadInfo.source}</WsTypography>
            </Box>
          </StyledItem>
        </Grid>
        {leadInfo.statusReason && (
          <Grid item xs={4}>
            <StyledItem>
              <WsTypography color={WsTypoColors.SECONDARY}>Last Status Change Reason</WsTypography>
              <Box width="50%">
                <WsTypography>{leadInfo.statusReason}</WsTypography>
              </Box>
            </StyledItem>
          </Grid>
        )}
        <Grid container item xs={12}>
          <Grid item xs={2}>
            <Item>
              <WsTypography color={WsTypoColors.SECONDARY}>Description</WsTypography>
            </Item>
          </Grid>
          <Grid item xs={10}>
            <Item sx={{ pl: 0 }}>
              <WsTypography>{leadInfo.description}</WsTypography>
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default LeadInfoTab;
